import { useEffect, useState } from 'react';

/* A media query as React state — the same shape as motion/overlay.tsx's
 * useIsPhone, generalised to any query.
 *
 * FALSE WHERE THERE IS NO matchMedia (jsdom, SSR). Every caller must treat
 * false as "the ordinary, wide layout", so a test environment renders the
 * shape that has no portal and no fixed positioning. */
const read = (query: string): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(query).matches;

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => read(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);

    onChange();
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);

      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);

    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
};
